import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService } from './data.service';
import { ListDTO, ListWriteDTO, SharedListMemberDTO } from '../interfaces/list';

@Injectable({
  providedIn: 'root'
})
export class ListService {

  constructor(private dataService: DataService) { }

  saveList(listId: number, list: ListWriteDTO): Observable<ListDTO> {
    if (listId && listId > 0) {
      return this.dataService.updateList(listId, list);
    } else {
      return this.dataService.createList(list);
    }
  }

  deleteList(list: ListDTO): Observable<any> {
    if (list && list.id > 0) {
      return this.dataService.deleteList(list.id);
    } else return of(null);
  }

  getLists(): Observable<any> {
    return this.dataService.getLists();
  }

  getSharedLists(): Observable<any> {
    return this.dataService.getSharedLists();
  }

  getList(listId: number): Observable<any> {
    return this.dataService.getList(listId);
  }

  shareList(listId: number, emailAddress: string) {
    return this.dataService.shareList(listId, emailAddress);
  }

  getSharedListMembers(listId: number) {
    return this.dataService.getSharedListMembers(listId);
  }

  addSharedListMember(sharedListMember: SharedListMemberDTO) {
    return this.dataService.addSharedListMember(sharedListMember);
  }

  removeSharedListMember(sharedListMember: SharedListMemberDTO) {
    return this.dataService.removeSharedListMember(sharedListMember);
  }
}
